<script>
export default {
  props: {
    veeNameLeft: {
      type: String,
      default: null,
    },
    veeNameRight: {
      type: String,
      default: null,
    },
    rules: {
      type: [Object, Boolean],
      require: false,
      default: () => {},
    },
    hideLabel: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    mainLabel: {
      type: String,
      default: '',
    },
    min: {
      type: [String, Number],
      default: null,
    },
    step: {
      type: [String, Number],
      default: 'any',
    },
    max: {
      type: [String, Number],
      default: null,
    },
    left: {
      type: [String, Number],
      default: null,
    },
    right: {
      type: [String, Number],
      default: null,
    },
  },
  computed: {
    leftComputed: {
      get() {
        return this.left
      },
      set(value) {
        this.$emit('update:value', {
          left: value,
          right: this.right,
        })
      },
    },
    rightComputed: {
      get() {
        return this.right
      },
      set(value) {
        this.$emit('update:value', {
          left: this.left,
          right: value,
        })
      },
    },
  },
}
</script>

<template>
  <validation-provider
    :rules="{
      valueRange: { min: min, max: max },
      numberRange: { min: leftComputed, max: max },
    }"
  >
    <div class="mb-2">{{ mainLabel }}</div>
    <div id="base-number-input-range" class="d-flex align-items-baseline">
      <BaseInput
        v-model="leftComputed"
        v-bind="$attrs"
        type="number"
        :min="min"
        :max="max"
        :vee-name="veeNameLeft"
        :step="step"
        :rules="{
          ...rules,
          valueRange: { min: min, max: max },
        }"
      >
        <template v-if="!hideLabel" v-slot:append-content>
          {{ label }}
        </template>
      </BaseInput>
      <div class="mx-1">
        ~
      </div>
      <BaseInput
        v-model="rightComputed"
        type="number"
        v-bind="$attrs"
        :min="min"
        :max="max"
        :vee-name="veeNameRight"
        :step="step"
        :rules="{
          ...rules,
          valueRange: { min: min, max: max },
          numberRange: { min: leftComputed, max: max },
        }"
      >
        <template v-if="!hideLabel" v-slot:append-content>
          {{ label }}
        </template>
      </BaseInput>
    </div>
  </validation-provider>
</template>

<style lang="scss" scoped>
#base-number-input-range {
  ::v-deep > span {
    width: 50%;
  }
}
</style>
